import React, { useEffect, useState } from 'react';
import classes from './LoadingScreen.module.scss';
import { assetUrl } from '../../utils/metadata';

interface LoadingScreenProps {
  type?: 'progress' | 'circular' | 'percentage';
  background?: 'transparent' | 'dark';
  titleKey?: string;
  fallbackText?: string;
  progress?: number;
  transitionImage?: string;
  transitionImage2?: string;
}

export const LoadingScreen = ({
  titleKey = 'staticTranslations.loadingScreen.default',
  fallbackText = 'Loading assets...',
  type = 'progress',
  background = 'dark',
  progress: externalProgress,
  transitionImage,
  transitionImage2,
}: LoadingScreenProps) => {
  const [progress, setProgress] = useState(0);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (type === 'progress') {
      interval = setInterval(() => {
        if (progress < 85) {
          setProgress((prevState) => prevState + 1);
        }
      }, 100);
    }
    return () => {
      clearInterval(interval);
    };
  }, [type, progress]);

  // Use external progress if provided (for percentage type)
  const displayProgress =
    type === 'percentage' ? externalProgress ?? 0 : progress;

  return (
    <div className={`${classes.loadingScreen} ${classes[background]}`}>
      {/* Transition Images */}
      {type === 'percentage' && (transitionImage || transitionImage2) && (
        <div className={classes.transitionImages}>
          {transitionImage && (
            <img
              className={classes.transition}
              src={`${assetUrl}${transitionImage}`}
              alt="Transition"
            />
          )}
          {transitionImage2 && (
            <img
              className={classes.transition}
              src={`${assetUrl}${transitionImage2}`}
              alt="Transition"
            />
          )}
        </div>
      )}

      <div className={classes.content}>
        {type === 'percentage' ? (
          <div className={classes.loaderContainer}>
            <div
              className={classes.progressBarContainer}
              style={{ width: isMobile ? '160px' : '238px' }}
            >
              <div
                className={classes.progressBarFill}
                style={{ width: `${displayProgress}%` }}
              />
            </div>
            <div className={classes.progressPercentage}>
              {Math.round(displayProgress)}%
            </div>
          </div>
        ) : type === 'progress' ? (
          <div className={classes.meter}>
            <span className={classes.progressIndicator}> </span>
          </div>
        ) : (
          <div className={classes.circularLoader}>
            {/* Circular loader placeholder or SVG if needed */}
            <svg className={classes.loaderSvg} viewBox="0 0 50 50">
              <circle
                className={classes.path}
                cx="25"
                cy="25"
                r="20"
                fill="none"
                strokeWidth="5"
              ></circle>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;
